var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.175,
    height: 12.474,
    viewBox: "0 0 14.175 12.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-briefcase",
    "data-name": "Icon awesome-briefcase",
    d: "M8.86,10.715a.444.444,0,0,1-.443.446H5.759a.444.444,0,0,1-.443-.446V9.378H0v4.01a1.366,1.366,0,0,0,1.329,1.337H12.846a1.366,1.366,0,0,0,1.329-1.337V9.378H8.86Zm3.987-5.792H10.631V3.587A1.366,1.366,0,0,0,9.3,2.25H4.873A1.366,1.366,0,0,0,3.544,3.587V4.923H1.329A1.366,1.366,0,0,0,0,6.26V8.487H14.175V6.26A1.366,1.366,0,0,0,12.846,4.923Zm-3.987,0H5.316V4.032H8.86Z",
    transform: "translate(0 -2.25)",
    fill: "#1a1d4d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.85ab2eeb11b656561be1086f37f931e1.svg";
export { ForwardRef as ReactComponent };